import { Link } from '@cloudscape-design/components';

export type PersonProfileProps = {
  url: string;
  image: string;
  title: string;
  subtitle: string;
  children?: React.ReactNode;
};

export default function PersonProfile(props: PersonProfileProps) {
  return (
    <div className="client flex flex-col items-center p-4 m-4">
      <Link href={props.url} target="_blank">
        <img alt={`${props.title} Logo`} className="max-h-64 mb-4 rounded-lg" src={props.image} />
      </Link>
      <h3 className="text-xl font-bold text-center">{props.title}</h3>
      <h4 className="text-lg mb-2 text-center">{props.subtitle}</h4>
      {props.children}
    </div>
  );
}

export const PEOPLE = [
  <PersonProfile
    key="max"
    image="https://cdn.aiescape.io/max.png"
    subtitle="Founder & CEO"
    title="Max Weinzierl"
    url="https://maxnlp.ai"
  >
    <p>
      Max is the founder and CEO of AI Escape. He has a background in Computer Science and has been
      working in the field of AI for over 10 years. He is currently pursuing a Ph.D. in Computer
      Science at the University of Texas at Dallas, where his research focuses on Natural Language
      Processing on social media for public health.
    </p>
  </PersonProfile>,
  <PersonProfile
    key="emelia"
    image="https://cdn.aiescape.io/emelia-2025.JPG"
    subtitle="COO"
    title="Emelia Joe-Gammill"
    url="https://www.linkedin.com/in/emelia-joe-gammill-a4006b225/"
  >
    <p>
      Emelia is the Chief Operating Officer at AI Escape. She has a background in customer service,
      human resources, and operations management. She has been instrumental in driving operational
      excellence, leveraging advanced data analytics to revolutionize how we deliver engaging and
      immersive products and services to our clients.
    </p>
  </PersonProfile>,
];
